<template>
  <div
    :class="{
      'container mx-auto p-0': true,
    }"
  >
    <div
      :class="{
        'grid grid-cols-12 gap-6': true,
      }"
    >
      <div
        :class="{
          'col-span-12 lg:col-span-6': true,
        }"
      >
        <PortableText
          v-if="heading?.flipCardPortableText"
          :class="{
            'text-center md:mb-0 md:text-left lg:my-70px': true,
          }"
          :portable-data="heading?.flipCardPortableText"
        />
      </div>
      <div
        :class="{
          'col-span-12 lg:col-span-6': true,
        }"
      >
        <div
          v-for="(card, index) in cards"
          :key="index"
        >
          <TwoColumnCard v-bind="card" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import TwoColumnCard from '~/components/Atmos/ManualCard/TwoColumnCard.vue';
import type { ContentCard } from '~/sanity/types';
defineProps<ContentCard>();
</script>

<style></style>
